module.exports = __webpack_public_path__ + "static/domobile-87d6c94cb7e4c703669fc6036bba240d.jpg";